import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Nav, Tab, Form, ListGroup, Button, Modal, ProgressBar, Breadcrumb, OverlayTrigger, Tooltip, Card, Badge, Navbar } from 'react-bootstrap';
import smsPic from "../../assets/img/mobileScreens/SMS.png"
import { useCreateSMSTemplateMutation } from "Services/services";
import moment from "moment-timezone";
import { CheckCircleIcon, ClockIcon, HomeIcon, ShieldExclamationIcon, XCircleIcon } from "@heroicons/react/solid";
import { IoMdAddCircle } from "react-icons/io";
import { useHistory } from "react-router-dom";
import { Routes } from "routes";
import SmsCalculator from "pages/SmsCalculator";
import EmojiPicker from "emoji-picker-react";
import { FaSmile } from 'react-icons/fa';
import { useStoreApi } from "react-flow-renderer";
import { IoLogoWhatsapp } from "react-icons/io5";
import Select from 'react-select';

export default () => {
    const [showModal, setShowModal] = useState(false);
    const [progress, setProgress] = useState(0);
    const [reason, setReason] = useState('');
    const [variant, setVariant] = useState('primary');
    const history = useHistory();
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const emojiPickerRef = useRef(null);
    const [smsDetails, setSmsDetails] = useState({
        textLength: 0,
        remaining: 0,
        numberOfSMS: 1,
        encoding: 'GSM 7'
    });


    // This will return the form inputs
    const formRef = useRef(null);
    const handleCloseModal = () => {
        setShowModal(false);
        setTimeout(() => {
            setProgress(0);
        }, 100);
        setReason('');
        setVariant('primary');
    };
    // This will reset the form inputs
    const handleRefresh = () => {
        if (formRef.current) {
            formRef.current.reset();
        }
        setValidated(false);
        setShowModal(false);
        setTimeout(() => {
            setProgress(0);
        }, 100);
        history.push(Routes.Templates.path);
        setReason('');
        setVariant('primary');
    };
    useEffect(() => {
        if (showModal) {
            const interval = setInterval(() => {
                setProgress(prevProgress => {
                    if (prevProgress >= 100) {
                        clearInterval(interval);
                        return 100;
                    }
                    return Math.min(prevProgress + 5, 95);
                });
            }, 100);
        }
    }, [showModal]);

    // Toggle the emoji picker visibility
    const toggleEmojiPicker = () => {
        setShowEmojiPicker((prev) => !prev);
    };

    // Append emoji to the message field in form state
    const handleEmojiClick = (emojiData) => {
        const emoji = emojiData.emoji; // Get the emoji character
        setFormValues((prevValues) => ({
            ...prevValues,
            template_content: (prevValues.template_content || '') + emoji // Append emoji to the message field
        }));
    };

    // Effect to handle clicks outside the emoji picker
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
                setShowEmojiPicker(false); // Close emoji picker if clicked outside
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleCalculation = ({ textLength, remaining, numberOfSMS, encoding }) => {
        setSmsDetails({ textLength, remaining, numberOfSMS, encoding });
    };

    const [formValues, setFormValues] = useState({});
    const [createTemp] = useCreateSMSTemplateMutation();
    const handleChange = (e) => {
        setFormValues((prevValues) => ({
            ...prevValues,
            [e.target.name]: e.target.value,
            language: "En"
        }));
    };

    const handleSelectChange = (selectedOption, actionMeta) => {
        setFormValues((prevValues) => ({
            ...prevValues,
            [actionMeta.name]: selectedOption ? selectedOption.value : "",
            language: "En"
        }));
    };

    //add variables
    const textareaRef = useRef(null);
    const [count, setCount] = useState(1);
    const AddAuthVars = () => {
        const textarea = textareaRef.current;

        const varToAdd = `{{${count}}}`;

        // Get the cursor position
        const startPos = textarea.selectionStart;
        const endPos = textarea.selectionEnd;

        // Get current textarea content (which could be empty)
        const currentContent = formValues.template_content || ""; // Handle empty string case

        // Insert the variable at the cursor position
        const updatedValue =
            currentContent.substring(0, startPos) +  // Everything before the cursor
            varToAdd +                              // The variable to insert
            currentContent.substring(endPos);        // Everything after the cursor

        // Update the state with the new value
        setFormValues({ ...formValues, template_content: updatedValue });

        // Maintain the cursor position after insertion
        setTimeout(() => {
            textarea.selectionStart = textarea.selectionEnd = startPos + varToAdd.length;
            textarea.focus();
        }, 0);

        setCount(prevCount => prevCount + 1);
    };

    //post
    const [validated, setValidated] = useState(false);
    const submitSMS = (e) => {
        // Prevent the default form submission
        e.preventDefault();

        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
            return;
        }

        setShowModal(true);
        createTemp(formValues)
            .then((success) => {
                if (success?.data?.statusCode >= 200 && success?.data?.statusCode <= 204) {
                    setReason(success?.data?.message);
                    setVariant('tertiary');
                    setProgress(100);
                } else if (success?.data?.statusCode > 300) {
                    setReason(success?.data?.message || 'Upload failed!');
                    setVariant('warning');
                    setProgress(100);
                }
            })
            .catch((error) => {
                setReason(error?.message || 'Upload failed');
                setVariant('warning');
                setShowModal(true);
                setProgress(100);
            });
    }

    //preview
    const date = moment();
    const currentTime = date.format("[Today], h:mm A");
    const highlightTemplateContent = (content) => {
        // Regex to match any {{digit}} pattern
        const parts = content.split(/(\{\{\d+\}\})/);

        return parts.map((part, index) =>
            // Check if part matches the pattern {{digit}}
            /\{\{\d+\}\}/.test(part) ? (
                <span key={index} style={{ color: 'blue' }}>
                    {part}
                </span>
            ) : (
                part
            )
        );
    };


    const categoryOptions = [
        { value: 'OTHER', label: 'Other' },
        { value: 'AUTO', label: 'Auto' },
        { value: 'BEAUTY', label: 'Beauty' },
        { value: 'APPAREL', label: 'Apparel' },
        { value: 'EDU', label: 'Education' },
        { value: 'ENTERTAIN', label: 'Entertainment' },
        { value: 'EVENT_PLAN', label: 'Event Planning' },
        { value: 'FINANCE', label: 'Finance' },
        { value: 'GROCERY', label: 'Grocery' },
        { value: 'GOVT', label: 'Government' },
        { value: 'HOTEL', label: 'Hotel' },
        { value: 'HEALTH', label: 'Health' },
        { value: 'NONPROFIT', label: 'Nonprofit' },
        { value: 'PROF_SERVICES', label: 'Professional Services' },
        { value: 'RETAIL', label: 'Retail' },
        { value: 'TRAVEL', label: 'Travel' },
        { value: 'RESTAURANT', label: 'Restaurant' }
    ];

    const [websites, setWebsites] = useState([""]);

    // handle website data
    const handleWebsites = (value, index) => {
        setWebsites(prev => {
            const updated = [...prev];
            updated[index] = value;
            return updated;
        });
    };

    console.log('websites', websites)
    const deleteWebsite = (index) => {
        setWebsites(prev => prev.filter((_, indx) => indx !== index));
    }
    const addWebsite = () => {
        if (websites.length < 3) {
            setWebsites(prev => [...prev, '']);
        } else {
            alert("Maximum 3 websites are allowed!");
        }
    }





    return (
        <>

            <Tab.Container defaultActiveKey="profile">
                <Row>
                    <Col lg={4} className="pe-0">
                        <div className="card p-2 me-0" style={{ minHeight: '100vh' }}>
                            <Navbar className="bg-body-tertiary py-0" sticky="top">
                                <Form.Control
                                    type="text"
                                    placeholder="Search by Number/Text"
                                    className=""
                                />
                            </Navbar>
                            <ListGroup className="border mt-2">
                                <ListGroup.Item action as="li" className="d-flex justify-content-between align-items-start" active>
                                    <div className="me-auto">
                                        <div className="fw-bold d-flex align-items-center gap-2"> <IoLogoWhatsapp style={{ color: "#25D366" }} />Subheading</div>
                                        Cras justo odio
                                    </div>
                                    <Badge bg="primary" pill>
                                        14
                                    </Badge>
                                </ListGroup.Item>
                            </ListGroup>
                        </div>
                    </Col>
                    <Col lg={8} className="ps-0">
                        <Tab.Container defaultActiveKey="profile">
                            <Card className="p-2">
                                <Nav fill variant="pills" className="flex-row gap-2">
                                    <Nav.Item>
                                        <Nav.Link eventKey="profile" className="w-25">
                                            Profile
                                        </Nav.Link>
                                    </Nav.Item>
                                    {/* <Nav.Item>
                                <Nav.Link eventKey="abc" className="">
                                    abc
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="def" className="">
                                    def
                                </Nav.Link>
                            </Nav.Item> */}
                                </Nav>
                            </Card>
                            <Tab.Content>
                                <Tab.Pane eventKey="profile">
                                    <Form noValidate validated={validated} ref={formRef} onSubmit={submitSMS}>
                                        <div className="card p-3">
                                            <Form.Group className="mb-3">
                                                <Form.Label>WhatsApp User-ID</Form.Label>
                                                <Form.Control type="number" disabled placeholder="98******74" name="userNumber" onChange={handleChange} />
                                            </Form.Group>

                                            <Form.Group className="mb-3 withChars">
                                                <Form.Label>About</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows="5"
                                                    required
                                                    placeholder="Enter Message Content"
                                                    name="template_content" // Ensure this matches the state field you are updating
                                                    value={formValues.template_content} // Bind textarea value to message state
                                                    onChange={handleChange} // Handle input changes
                                                />
                                                <p className="chars_count ta">({formValues.template_content === undefined ? "0" : formValues.template_content.length}/139)</p>
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label>Profile Picture</Form.Label>
                                                <Form.Control
                                                    as="image"
                                                    required
                                                    name="profilePicture" // Ensure this matches the state field you are updating
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="card p-3 mt-2">
                                            <h5>Business Profile</h5>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Address</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    required
                                                    placeholder="ABC Street"
                                                    name="address" // Ensure this matches the state field you are updating
                                                // value={formValues.template_content} // Bind textarea value to message state
                                                // onChange={handleChange} // Handle input changes
                                                />
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Business Description</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    required
                                                    placeholder="Some Description..."
                                                    name="bDesc" // Ensure this matches the state field you are updating
                                                // value={formValues.template_content} // Bind textarea value to message state
                                                // onChange={handleChange} // Handle input changes
                                                />
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Contact Email</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    required
                                                    placeholder="abc@example.com"
                                                    name="email" // Ensure this matches the state field you are updating
                                                // value={formValues.template_content} // Bind textarea value to message state
                                                // onChange={handleChange} // Handle input changes
                                                />
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Business Category</Form.Label>
                                                <Select
                                                    name="businessCategory"
                                                    value={categoryOptions.find(option => option.value === formValues.businessCategory)}
                                                    onChange={handleSelectChange}
                                                    options={categoryOptions}
                                                    placeholder="Select Category"
                                                    isRequired={true}
                                                />
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <div className="d-flex justify-content-between mb-2">
                                                    <Form.Label className="mb-0">Website</Form.Label>
                                                    <Button variant="secondary" type="button" className="py-1" onClick={() => addWebsite()}>
                                                        Add Website URL
                                                    </Button>
                                                </div>
                                                {websites.map((item, index) => (
                                                    <Form.Group key={index} className="d-flex align-items-center mb-2">
                                                        <Form.Control
                                                            type="url"
                                                            required
                                                            placeholder='https://example.com'
                                                            value={item}
                                                            onChange={(e) => handleWebsites(e.target.value, index)}
                                                        />
                                                        <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete Entry</Tooltip>}>
                                                            <Card.Link className="" onClick={() => deleteWebsite(index)}>
                                                                <XCircleIcon className="icon icon-xs text-danger" />
                                                            </Card.Link>
                                                        </OverlayTrigger>
                                                    </Form.Group>
                                                ))}
                                            </Form.Group>

                                            <div className="d-flex mt-3 justify-content-end">
                                                <Button variant="secondary" type="submit" className="animate-up-2">
                                                    Submit
                                                </Button>
                                            </div>
                                        </div>
                                    </Form>


                                    {/* <Modal
                                    centered
                                    show={showModal}
                                    onHide={handleCloseModal}
                                    className={`modal-${variant}`}
                                    backdrop="static"
                                    keyboard={false}
                                >
                                    <Modal.Header className="mx-auto">
                                        <p className="lead mb-0 text-white">Creating SMS Template</p>
                                    </Modal.Header>
                                    <Modal.Body className="pt-0">
                                        <div className="py-3 px-5 text-center">
                                            {progress !== 100 ?
                                                (<span className="modal-icon display-1">
                                                    <ClockIcon className="icon icon-xl text-white" />
                                                </span>) :
                                                variant === 'tertiary' ?
                                                    (<span className="modal-icon display-1">
                                                        <CheckCircleIcon className="icon icon-xl text-white" />
                                                    </span>) :
                                                    <span className="modal-icon display-1">
                                                        <ShieldExclamationIcon className="icon icon-xl text-white" />
                                                    </span>
                                            }

                                            <Modal.Title className="text-white mb-3">
                                                {progress !== 100 ? <h3>Sending Request</h3> : variant === 'tertiary' ? <h3>Template Created Successfully</h3> : <h3>Something Went Wrong</h3>}
                                            </Modal.Title>
                                            <ProgressBar variant="secondary" now={progress} min={0} max={100} animated />
                                            {variant !== 'tertiary' ?
                                                <p className="mb-4 text-danger">
                                                    {reason}
                                                </p> : ''}
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer className="d-flex justify-content-center pt-0 pb-3">
                                        <Button variant="white" size="sm" className="text-primary fw-bold" onClick={handleRefresh}>
                                            OK
                                        </Button>
                                        {variant !== 'tertiary' && <Button variant="white" size="sm" className="text-primary fw-bold" onClick={handleCloseModal}>
                                            Retry
                                        </Button>}
                                    </Modal.Footer>
                                </Modal> */}
                                </Tab.Pane>

                                <Tab.Pane eventKey="abc">
                                </Tab.Pane>

                                <Tab.Pane eventKey="def">
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </Col>
                </Row>
            </Tab.Container>
        </>
    );
};
